export type AnalogDiagnostic = "fault" | "under-range" | "normal" | "over-range";

export interface AnalogDiagnosticPresentation {
  label: string;
  tone: "danger" | "warn" | "ok";
}

/**
 * Interpreta o campo `s` exclusivamente no modo AIN. Nos demais modos o
 * mesmo campo continua sendo estado binário/direção conforme o contrato.
 */
export function resolveAnalogDiagnostic(
  mode: unknown,
  status: unknown,
): AnalogDiagnostic | null {
  if (String(mode ?? "").trim().toUpperCase() !== "AIN") return null;

  if (
    status === null ||
    status === undefined ||
    typeof status === "boolean" ||
    (typeof status === "string" && status.trim() === "")
  ) {
    return null;
  }

  const numericStatus = typeof status === "number" ? status : Number(status);
  if (!Number.isInteger(numericStatus)) return null;

  switch (numericStatus) {
    case 0:
      return "fault";
    case 1:
      return "under-range";
    case 2:
      return "normal";
    case 3:
      return "over-range";
    default:
      return null;
  }
}

export function describeAnalogDiagnostic(
  diagnostic: AnalogDiagnostic,
): AnalogDiagnosticPresentation {
  switch (diagnostic) {
    case "fault":
      return { label: "FALHA DE SINAL", tone: "danger" };
    case "under-range":
      return { label: "ABAIXO DA FAIXA", tone: "warn" };
    case "over-range":
      return { label: "ACIMA DA FAIXA", tone: "warn" };
    case "normal":
      return { label: "NORMAL", tone: "ok" };
  }
}
